import { render, staticRenderFns } from "./spinningwheel.vue?vue&type=template&id=ad37159e&scoped=true"
import script from "./spinningwheel.vue?vue&type=script&lang=js"
export * from "./spinningwheel.vue?vue&type=script&lang=js"
import style0 from "./spinningwheel.vue?vue&type=style&index=0&id=ad37159e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad37159e",
  null
  
)

export default component.exports